import React from 'react'

export default function LoadingSymbol() {
    return (
        <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
    )
}
